// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// 获取本地数据
import "@/service/index.js"

Vue.config.productionTip = false

import '@/components/index' // 全局组件
import '@/plugins/PluginsIndex' // 第三方组件
import '@/assets/styles/StyleIndex' // 公用css
import '@/utils/common' // 公用助手函数
import '@/utils/packag' // 方法封装
import "@/assets/styles/iconfont.css"; // 字体图标
import '@/utils/lib-flexible' // 自适应

import '@/utils/dialog.js';
import draggable from 'vuedraggable';
Vue.use(draggable);
Vue.directive('dialogChange', {})

// md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import profile from '@/utils/configure' // 配置文件
Vue.prototype.$profile = profile;

// 封装表单验证
import rules from '@/utils/formCheck.js';
Vue.prototype.$rules = rules;


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js